(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-payment-done/assets/messages/successful-message-fractions.js') >= 0) return;  svs.modules.push('/components/payment/middleware-payment-done/assets/messages/successful-message-fractions.js');
"use strict";


const hasMultipleSharesToggleOn = svs.core.detect.feature('ft-marketplace-multiple-shares');
const fractionTitle = result => {
  var _result$getPaidPayabl;
  if (!hasMultipleSharesToggleOn) {
    return 'Du har köpt 1 andel';
  }
  const numberOfBoughtShares = result === null || result === void 0 || (_result$getPaidPayabl = result.getPaidPayableItemsDTO()[0]) === null || _result$getPaidPayabl === void 0 ? void 0 : _result$getPaidPayabl.purchasedShares;
  const suffix = numberOfBoughtShares > 1 ? 'andelar' : 'andel';
  return "Du har k\xF6pt ".concat(numberOfBoughtShares, " ").concat(suffix);
};
const fractionMessage = (payment, result) => {
  var _result$getPaidPayabl2;
  if (!hasMultipleSharesToggleOn) {
    return '';
  }
  const count = payment.count();
  const numberOfBoughtShares = result === null || result === void 0 || (_result$getPaidPayabl2 = result.getPaidPayableItemsDTO()[0]) === null || _result$getPaidPayabl2 === void 0 ? void 0 : _result$getPaidPayabl2.purchasedShares;
  if (count > numberOfBoughtShares) {
    const sharesDifference = count - numberOfBoughtShares;
    return "".concat(sharesDifference, " av dina andelsk\xF6p kunde tyv\xE4rr inte genomf\xF6ras.");
  }
  return '';
};
setGlobal('svs.components.payment.middleware.paymentDone.messages.successfulMessagesFractions', {
  fractionTitle,
  fractionMessage
});

 })(window);